var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4SmokeExtraction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 34v31h8v9.45l24-10.06V34H31zm18 31.92l-6 2.52v-8.57l6-2.53v8.58zM49 53l-6 2.53v-9.28L49 44v9zm10 8.73l-6 2.52v-8.59l6-2.53v8.6zm0-12.95l-6 2.53v-8.8l6-2.25v8.52zM16 4.5V2h4v2.5a6.51 6.51 0 006.67 6.5H30c6.87.27 12 5.88 12 13.28V30h-4v-5.69c0-5.39-3.79-9.31-9-9.31h-2.33A10.47 10.47 0 0116 4.5zm15 20.21A2.71 2.71 0 0028.29 22H17.67a11.132 11.132 0 01-3.73-.66 10.59 10.59 0 01-4.43-3 10.431 10.431 0 01-1.67-2.69A10.63 10.63 0 017 11.5V11h4v.5a6.33 6.33 0 001.56 4.2 6.89 6.89 0 005.21 2.3h10.52A6.7 6.7 0 0135 24.71V30h-4v-5.29z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Smoke_extraction.c1b330b4.svg";
export { SvgE4SmokeExtraction as ReactComponent };